// extracted by mini-css-extract-plugin
export default {"showcaseTime":"showcaseTime_showcaseTime__kWMvy","timeStamp":"showcaseTime_timeStamp__QkDwc"};